import {
  ADD_CONTRATISTA,
  ADD_DATOS_SUSTANCIA,
  ADD_DOSIMETRIA,
  ADD_EMPRESA,
  ADD_EQUIPO_RADIOLOGICO,
  ADD_ESTUDIO_AMBIENTAL,
  ADD_PROTECCION_RADIOLOGICA,
  ADD_PROVEEDOR_COMPRADOR,
  ADD_PUESTOS_ASOCIADOS,
  ADD_RESPONSABLE_INSTALACION,
  ADD_RESPONSABLE_USO,
  ADD_SUSTANCIA,
  ADD_TRABAJADORES,
  ADD_USOS,
  CLEAR_POST_RES,
  CLEAR_RES,
  CLEAR_SEARCHED_ESTABLECIMIENTO,
  DELETE_CONTRATISTA,
  DELETE_EMPRESA,
  EDIT_CONTRATISTA,
  EDIT_EMPRESA,
  GET_CIIU,
  GET_DATOS_CIOU_PUESTO,
  GET_DATOS_EQUIPO_RADIOLOGICO_ESTABLECIMIENTO,
  GET_DATOS_ESTABLECIMIENTOS,
  GET_ELEMENTOS_PROTECCION_PERSONAL,
  GET_EQUIPOS_RADIOLOGICOS,
  GET_FORMULARIO_ANTERIOR,
  GET_FORMULARIO_POR_ID,
  GET_FORMULARIOS_PRESENTADOS,
  GET_FRECUENCIAS_ESTUDIO,
  GET_MEDIDAS_PREVENTIVAS,
  GET_METODOLOGIAS_EMPLEADAS,
  GET_METODOS_DOSIMETRIA,
  GET_METODOS_PROCESAMIENTO,
  GET_MODOS_EMPLEO,
  GET_NOMINAS_ACTIVAS_ESTABLECIMIENTO,
  GET_INFO_ESTRUCTURA_ARCHIVO_CANCERIGENO,
  EXPORTAR_ARCHIVO_CANCERIGENOS,
  GET_PUESTOS,
  GET_SECTORES,
  GET_SUSTANCIAS,
  GET_TIPOS_CARACTERISTICAS,
  GET_TIPOS_DOSIMETRIA,
  GET_TIPOS_EQUIPOS_RADIOLOGICOS,
  GET_TIPOS_ESTUDIO,
  GET_TIPOS_EXAMENES_MEDICOS,
  GET_TIPOS_FUENTES,
  GET_TIPOS_METODOS_PROCESAMIENTO,
  GET_TIPOS_RADIACION,
  GET_UNIDADES_MEDIDA,
  GET_USOS_ORIGEN,
  GET_VALIDAR_DISPONIBILIDAD_RESOLUCION,
  POST_ALL_RES,
  POST_CABECERA_RES,
  POST_EQUIPO_RADIOLOGICO,
  POST_OBSERVACIONES_RES,
  POST_SEARCHED_RES,
  REMOVE_DOSIMETRIA,
  REMOVE_EQUIPO_RADIOLOGICO,
  REMOVE_ESTUDIO_AMBIENTAL,
  REMOVE_PROTRAD,
  REMOVE_PROVEEDOR_Comprador,
  REMOVE_PUESTOS,
  REMOVE_RESPINST,
  REMOVE_RESPUSO,
  REMOVE_SUSTANCIAS,
  REMOVE_TRABAJADORES,
  REMOVE_USOS,
  SET_EDIT_SUSTANCIA,
  SET_EQUIPO_RADIOLOGICO,
  SET_EQUIPO_RADIOLOGICO_DATA,
  GET_PRESENTACIONES_415,
  GET_FORMULARIOS_PRESENTACION,
  GET_MUESTRA_VIGENTE,
  POST_PRESENTACION_415
} from "../actions/resolucion";

const INITIAL_STATE = {
  searchedEstablecimiento: null,
  abmSustancia: {
    idTabla: null,
    sustancia: null,
    equiposRadiologicos: [],
    proveedores: [],
    compradores: [],
    estudios: [],
    usos: [],
  },
  abmEquiposRadiologicos: {
    idTabla: null,
    equipoRadiologicoData: null,
    dosimetria: [],
    respUso: [],
    respInst: [],
    protRad: [],
  },

  datosEquipoRadiologico: {
    loading: false,
    error: false,
    data: [],
  },
  postAllRes: {
    loading: false,
    error: false,
    data: {},
  },
  datosEstablecimiento: {
    loading: false,
    error: false,
    data: {},
  },
  formulariosPresentados: {
    loading: false,
    error: false,
    data: [],
  },
  validarDisponibilidadCargaRes: {
    loading: false,
    error: false,
    data: {},
  },
  postResolucion: {
    cabecera: {},
    observaciones: {},
    sustancias: [
    ],
    puestos: [
    ],
    trabajadores: [
    ]
  },
  sustancias: {
    data: [],
    loading: false,
    error: false,
  },
  unidadDeMedida: {
    data: [],
    loading: false,
    error: false,
  },
  equiposRadiologicos: {
    data: [],
    loading: false,
    error: false,
  },
  tiposMetodosProcesamiento: {
    data: [],
    loading: false,
    error: false,
  },
  tiposFuentes: {
    data: [],
    loading: false,
    error: false,
  },
  tiposEquiposRadiologicos: {
    data: [],
    loading: false,
    error: false,
  },
  tiposCaracteristicas: {
    data: [],
    loading: false,
    error: false,
  },
  tiposRadiacion: {
    data: [],
    loading: false,
    error: false,
  },
  postEquiposRadiologicos: {
    data: [],
    loading: false,
    error: false,
  },
  metodosDeProcesamiento: {
    data: [],
    loading: false,
    error: false,
  },
  tiposDosimetria: {
    data: [],
    loading: false,
    error: false,
  },
  metodosDosimetria: {
    data: [],
    loading: false,
    error: false,
  },
  tiposEstudio: {
    data: [],
    loading: false,
    error: false,
  },
  frecuenciasEstudio: {
    data: [],
    loading: false,
    error: false,
  },
  metodologiasEmpleadas: {
    data: [],
    loading: false,
    error: false,
  },
  usosOrigen: {
    data: [],
    loading: false,
    error: false,
  },
  modosEmpleo: {
    data: [],
    loading: false,
    error: false,
  },
  contratistas: {
    data: [],
    loading: false,
    error: false,
  },
  empresas: {
    data: [],
    loading: false,
    error: false,
  },
  ciiu: {
    data: [],
    loading: false,
    error: false,
  },
  puestos: {
    data: [],
    loading: false,
    error: false,
  },
  datosPuestoCiou: {
    data: [],
    loading: false,
    error: false,
  },
  elementosProteccionPersonal: {
    data: [],
    loading: false,
    error: false,
  },
  medidasPreventivas: {
    data: [],
    loading: false,
    error: false,
  },
  sectores: {
    data: [],
    loading: false,
    error: false,
  },
  tiposExamenesMedicos: {
    data: [],
    loading: false,
    error: false,
  },
  formularioAnterior: {
    loading: false,
    error: false,
    data: {},
  },
  formularioPorId: {
    loading: false,
    error: false,
    data: {},
  },
  nominasActivasEstablecimiento: {
    loading: false,
    error: false,
    data: [],
  },
  infoEstructuraArchivoCancerigeno: {
    loading: false,
    error: false,
    data: {},
  },
  exportarArchivoCancerigenos: {
    loading: false,
    error: false,
    data: null,
  },
  presentaciones415: {
    data: [],
    loading: false,
    error: false,
  },
  formulariosPresentacion: {
    data: [],
    loading: false,
    error: false,
  },
  muestraVigente: {
    data: null,
    loading: false,
    error: false,
  },
  postPresentacion415: {
    data: null,
    loading: false,
    error: false,
  },
};

const resolucion = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case `${GET_FORMULARIO_POR_ID}_PENDING`:
      return {
        ...state,
        formularioPorId: {
          ...state.formularioPorId,
          error: false,
          loading: true,
        },
      };
    case `${GET_FORMULARIO_POR_ID}_REJECTED`:
      return {
        ...state,
        formularioPorId: {
          ...state.formularioPorId,
          error: true,
          loading: false,
        },
      };
    case `${GET_FORMULARIO_POR_ID}_FULFILLED`:
      return {
        ...state,
        formularioPorId: {
          ...state.formularioPorId,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_FORMULARIO_ANTERIOR}_PENDING`:
      return {
        ...state,
        formularioAnterior: {
          ...state.formularioAnterior,
          error: false,
          loading: true,
        },
      };
    case `${GET_FORMULARIO_ANTERIOR}_REJECTED`:
      return {
        ...state,
        formularioAnterior: {
          ...state.formularioAnterior,
          error: true,
          loading: false,
        },
      };
    case `${GET_FORMULARIO_ANTERIOR}_FULFILLED`:
      return {
        ...state,
        formularioAnterior: {
          ...state.formularioAnterior,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_TIPOS_EXAMENES_MEDICOS}_PENDING`:
      return {
        ...state,
        tiposExamenesMedicos: {
          ...state.tiposExamenesMedicos,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_EXAMENES_MEDICOS}_REJECTED`:
      return {
        ...state,
        tiposExamenesMedicos: {
          ...state.tiposExamenesMedicos,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_EXAMENES_MEDICOS}_FULFILLED`:
      return {
        ...state,
        tiposExamenesMedicos: {
          ...state.tiposExamenesMedicos,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_CIIU}_PENDING`:
      return {
        ...state,
        ciiu: {
          ...state.ciiu,
          error: false,
          loading: true,
        },
      };
    case `${GET_CIIU}_REJECTED`:
      return {
        ...state,
        ciiu: {
          ...state.ciiu,
          error: true,
          loading: false,
        },
      };
    case `${GET_CIIU}_FULFILLED`:
      return {
        ...state,
        ciiu: {
          ...state.ciiu,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${POST_SEARCHED_RES}`:
      return {
        ...state,
        searchedEstablecimiento: action.payload,
      };
    case `${GET_DATOS_ESTABLECIMIENTOS}_PENDING`:
      return {
        ...state,
        datosEstablecimiento: {
          ...state.datosEstablecimiento,
          error: false,
          loading: true,
        },
      };
    case `${GET_DATOS_ESTABLECIMIENTOS}_REJECTED`:
      return {
        ...state,
        datosEstablecimiento: {
          ...state.datosEstablecimiento,
          error: true,
          loading: false,
        },
      };
    case `${GET_DATOS_ESTABLECIMIENTOS}_FULFILLED`:
      return {
        ...state,
        datosEstablecimiento: {
          ...state.datosEstablecimiento,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${POST_ALL_RES}_PENDING`:
      return {
        ...state,
        postAllRes: {
          ...state.postAllRes,
          error: false,
          loading: true,
        },
      };
    case `${POST_ALL_RES}_REJECTED`:
      return {
        ...state,
        postAllRes: {
          ...state.postAllRes,
          error: true,
          loading: false,
        },
      };
    case `${POST_ALL_RES}_FULFILLED`:
      return {
        ...state,
        postAllRes: {
          ...state.postAllRes,
          error: false,
          loading: false,
          data: action.payload,
        },
      };
    case `${GET_FORMULARIOS_PRESENTADOS}_PENDING`:
      return {
        ...state,
        formulariosPresentados: {
          ...state.formulariosPresentados,
          error: false,
          loading: true,
        },
      };
    case `${GET_FORMULARIOS_PRESENTADOS}_REJECTED`:
      return {
        ...state,
        formulariosPresentados: {
          ...state.formulariosPresentados,
          error: true,
          loading: false,
        },
      };
    case `${GET_FORMULARIOS_PRESENTADOS}_FULFILLED`:
      return {
        ...state,
        formulariosPresentados: {
          ...state.formulariosPresentados,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${GET_VALIDAR_DISPONIBILIDAD_RESOLUCION}_PENDING`:
      return {
        ...state,
        validarDisponibilidadCargaRes: {
          ...state.validarDisponibilidadCargaRes,
          error: false,
          loading: true,
        },
      };
    case `${GET_VALIDAR_DISPONIBILIDAD_RESOLUCION}_REJECTED`:
      return {
        ...state,
        validarDisponibilidadCargaRes: {
          ...state.validarDisponibilidadCargaRes,
          error: true,
          loading: false,
        },
      };
    case `${GET_VALIDAR_DISPONIBILIDAD_RESOLUCION}_FULFILLED`:
      return {
        ...state,
        validarDisponibilidadCargaRes: {
          ...state.validarDisponibilidadCargaRes,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${POST_CABECERA_RES}`:
      return {
        ...state,
        postResolucion: {
          ...state.postResolucion,
          cabecera: action.payload,
        },
      };
    case `${POST_OBSERVACIONES_RES}`:
      return {
        ...state,
        postResolucion: {
          ...state.postResolucion,
          observaciones: action.payload,
        },
      };
    case CLEAR_SEARCHED_ESTABLECIMIENTO:
      return {
        ...state,
        searchedEstablecimiento: null,
      };

    case `${GET_PUESTOS}_PENDING`:
      return {
        ...state,
        puestos: {
          ...state.puestos,
          error: false,
          loading: true,
        },
      };
    case `${GET_PUESTOS}_REJECTED`:
      return {
        ...state,
        puestos: {
          ...state.puestos,
          error: true,
          loading: false,
        },
      };
    case `${GET_PUESTOS}_FULFILLED`:
      return {
        ...state,
        puestos: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };

    case `${GET_DATOS_CIOU_PUESTO}_PENDING`:
      return {
        ...state,
        datosPuestoCiou: {
          ...state.datosPuestoCiou,
          error: false,
          loading: true,
        },
      };
    case `${GET_DATOS_CIOU_PUESTO}_REJECTED`:
      return {
        ...state,
        datosPuestoCiou: {
          ...state.datosPuestoCiou,
          error: true,
          loading: false,
        },
      };
    case `${GET_DATOS_CIOU_PUESTO}_FULFILLED`:
      return {
        ...state,
        datosPuestoCiou: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_MEDIDAS_PREVENTIVAS}_PENDING`:
      return {
        ...state,
        medidasPreventivas: {
          ...state.medidasPreventivas,
          error: false,
          loading: true,
        },
      };
    case `${GET_MEDIDAS_PREVENTIVAS}_REJECTED`:
      return {
        ...state,
        medidasPreventivas: {
          ...state.medidasPreventivas,
          error: true,
          loading: false,
        },
      };
    case `${GET_MEDIDAS_PREVENTIVAS}_FULFILLED`:
      return {
        ...state,
        medidasPreventivas: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };

    case `${GET_ELEMENTOS_PROTECCION_PERSONAL}_PENDING`:
      return {
        ...state,
        elementosProteccionPersonal: {
          ...state.elementosProteccionPersonal,
          error: false,
          loading: true,
        },
      };
    case `${GET_ELEMENTOS_PROTECCION_PERSONAL}_REJECTED`:
      return {
        ...state,
        elementosProteccionPersonal: {
          ...state.elementosProteccionPersonal,
          error: true,
          loading: false,
        },
      };
    case `${GET_ELEMENTOS_PROTECCION_PERSONAL}_FULFILLED`:
      return {
        ...state,
        elementosProteccionPersonal: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };

    case ADD_PUESTOS_ASOCIADOS:
      let puestosAux = [...state.postResolucion.puestos];
      if (action.payload.id !== null && action.payload.id !== undefined) {
        puestosAux[action.payload.id] = action.payload.values;
      } else {
        puestosAux.push(action.payload.values);
      }
      return {
        ...state,
        postResolucion: {
          ...state.postResolucion,
          puestos: puestosAux,
        },
      };
    case REMOVE_PUESTOS:
      // Usar puesto y sustancia en vez de id de tabla
      let indexPuestos = [];
      state.postResolucion.puestos.forEach((puesto, index) => {
        if (action.payload.some((p) => puesto.puesto === p.puesto && puesto.sustancia === p.sustancia)) {
          indexPuestos.push(index);
        }
      })

      let trabajadoresSinPuestos = [...state.postResolucion.trabajadores];
      action.payload.forEach(puesto => {
        trabajadoresSinPuestos.forEach((trabajador) => {
          if (trabajador.idPuesto === puesto.puesto) {
            delete trabajador.examenes[puesto.sustancia]
          }
        })
      });
      return {
        ...state,
        postResolucion: {
          ...state.postResolucion,
          puestos: state.postResolucion.puestos.filter(
            (v, i) => !indexPuestos.includes(i)
          ),
        },
        trabajadores: trabajadoresSinPuestos,
      };
    case ADD_TRABAJADORES:
      let trabajadoresAux = [...state.postResolucion.trabajadores];
      if (action.payload.id !== null && action.payload.id !== undefined) {
        trabajadoresAux[action.payload.id] = action.payload.values;
      } else {
        trabajadoresAux.push(action.payload.values);
      }
      return {
        ...state,
        postResolucion: {
          ...state.postResolucion,
          trabajadores: trabajadoresAux,
        },
      };
    case REMOVE_TRABAJADORES:
      return {
        ...state,
        postResolucion: {
          ...state.postResolucion,
          trabajadores: state.postResolucion.trabajadores.filter(
            (v, i) => !action.payload.includes(i)
          ),
        },
      };
    case ADD_SUSTANCIA:
      let sustanciasAux = [...state.postResolucion.sustancias];
      if (action.payload.id !== null && action.payload.id !== undefined) {
        sustanciasAux[action.payload.id] = action.payload.values;
      } else {
        // Id = maxId+1 para uso en puestos y trabajadores. Ya que el id de tabla cambia al borrar elementos no sirve para estas operaciones
        sustanciasAux.push({
          ...action.payload.values,
          id: (action.payload?.values?.id)
            ? action.payload.values.id
            : sustanciasAux.length !== 0
              ? Math.max(...sustanciasAux.map((s) => s.id)) + 1
              : 0
        });
      }
      return {
        ...state,
        postResolucion: {
          ...state.postResolucion,
          sustancias: sustanciasAux,
        },
      };
    case REMOVE_SUSTANCIAS:
      return {
        ...state,
        postResolucion: {
          ...state.postResolucion,
          sustancias: state.postResolucion.sustancias.filter(
            (v, i) => !action.payload.includes(i)
          ),
        },
      };
    case ADD_PROTECCION_RADIOLOGICA:
      let protRadAux = [...state.abmEquiposRadiologicos.protRad];
      if (action.payload.id !== null) {
        protRadAux[action.payload.id] = action.payload.values;
      } else {
        protRadAux.push(action.payload.values);
      }
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          protRad: [...protRadAux],
        },
      };
    case ADD_RESPONSABLE_INSTALACION:
      let respInstAux = [...state.abmEquiposRadiologicos.respInst];
      if (action.payload.id !== null) {
        respInstAux[action.payload.id] = action.payload.values;
      } else {
        respInstAux.push(action.payload.values);
      }
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          respInst: [...respInstAux],
        },
      };
    case ADD_RESPONSABLE_USO:
      let respUsoAux = [...state.abmEquiposRadiologicos.respUso];
      if (action.payload.id !== null) {
        respUsoAux[action.payload.id] = action.payload.values;
      } else {
        respUsoAux.push(action.payload.values);
      }
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          respUso: [...respUsoAux],
        },
      };
    case ADD_DOSIMETRIA:
      let dosimetriaAux = [...state.abmEquiposRadiologicos.dosimetria];
      if (action.payload.id !== null) {
        dosimetriaAux[action.payload.id] = action.payload.values;
      } else {
        dosimetriaAux.push(action.payload.values);
      }

      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          dosimetria: [...dosimetriaAux],
        },
      };
    case SET_EQUIPO_RADIOLOGICO:
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...INITIAL_STATE.abmEquiposRadiologicos,
          ...action.payload.values,
          idTabla: action.payload.id,
        },
      };
    case SET_EQUIPO_RADIOLOGICO_DATA:
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          equipoRadiologicoData: action.payload,
        },
      };

    case REMOVE_DOSIMETRIA:
      let dosimetrias = [...state.abmEquiposRadiologicos.dosimetria];
      dosimetrias.splice(action.payload, 1);
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          dosimetria: dosimetrias,
        },
      };

    case REMOVE_PROTRAD:
      let proteccionRadiologica = [...state.abmEquiposRadiologicos.protRad];
      proteccionRadiologica.splice(action.payload, 1);
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          protRad: proteccionRadiologica,
        },
      };

    case REMOVE_RESPINST:
      let responsablesInstalacion = [...state.abmEquiposRadiologicos.respInst];
      responsablesInstalacion.splice(action.payload, 1);
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          respInst: responsablesInstalacion,
        },
      };

    case REMOVE_RESPUSO:
      let responsablesUso = [...state.abmEquiposRadiologicos.respUso];
      responsablesUso.splice(action.payload, 1);
      return {
        ...state,
        abmEquiposRadiologicos: {
          ...state.abmEquiposRadiologicos,
          respUso: responsablesUso,
        },
      };
    case REMOVE_EQUIPO_RADIOLOGICO:
      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          equiposRadiologicos: state.abmSustancia.equiposRadiologicos.filter(
            (v, i) => !action.payload.includes(i)
          ),
        },
      };
    case ADD_EQUIPO_RADIOLOGICO:
      let equiposRadiologicosAux = [...state.abmSustancia.equiposRadiologicos];
      if (action.payload.id !== null) {
        equiposRadiologicosAux[action.payload.id] = action.payload.values;
      } else {
        equiposRadiologicosAux.push(action.payload.values);
      }

      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          equiposRadiologicos: equiposRadiologicosAux,
        },
      };
    case `${GET_METODOS_DOSIMETRIA}_PENDING`:
      return {
        ...state,
        metodosDosimetria: {
          ...state.metodosDosimetria,
          error: false,
          loading: true,
        },
      };
    case `${GET_METODOS_DOSIMETRIA}_REJECTED`:
      return {
        ...state,
        metodosDosimetria: {
          ...state.metodosDosimetria,
          error: true,
          loading: false,
        },
      };
    case `${GET_METODOS_DOSIMETRIA}_FULFILLED`:
      return {
        ...state,
        metodosDosimetria: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_TIPOS_DOSIMETRIA}_PENDING`:
      return {
        ...state,
        tiposDosimetria: {
          ...state.tiposDosimetria,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_DOSIMETRIA}_REJECTED`:
      return {
        ...state,
        tiposDosimetria: {
          ...state.tiposDosimetria,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_DOSIMETRIA}_FULFILLED`:
      return {
        ...state,
        tiposDosimetria: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_SECTORES}_PENDING`:
      return {
        ...state,
        sectores: {
          ...state.sectores,
          error: false,
          loading: true,
        },
      };
    case `${GET_SECTORES}_REJECTED`:
      return {
        ...state,
        sectores: {
          ...state.sectores,
          error: true,
          loading: false,
        },
      };
    case `${GET_SECTORES}_FULFILLED`:
      return {
        ...state,
        sectores: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${POST_EQUIPO_RADIOLOGICO}_PENDING`:
      return {
        ...state,
        postEquiposRadiologicos: {
          ...state.postEquiposRadiologicos,
          error: false,
          loading: true,
        },
      };
    case `${POST_EQUIPO_RADIOLOGICO}_REJECTED`:
      return {
        ...state,
        postEquiposRadiologicos: {
          ...state.postEquiposRadiologicos,
          error: true,
          loading: false,
        },
      };
    case `${POST_EQUIPO_RADIOLOGICO}_FULFILLED`:
      return {
        ...state,
        postEquiposRadiologicos: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_METODOS_PROCESAMIENTO}_PENDING`:
      return {
        ...state,
        metodosDeProcesamiento: {
          ...state.metodosDeProcesamiento,
          error: false,
          loading: true,
        },
      };
    case `${GET_METODOS_PROCESAMIENTO}_REJECTED`:
      return {
        ...state,
        metodosDeProcesamiento: {
          ...state.metodosDeProcesamiento,
          error: true,
          loading: false,
        },
      };
    case `${GET_METODOS_PROCESAMIENTO}_FULFILLED`:
      return {
        ...state,
        metodosDeProcesamiento: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_TIPOS_METODOS_PROCESAMIENTO}_PENDING`:
      return {
        ...state,
        tiposMetodosProcesamiento: {
          ...state.tiposMetodosProcesamiento,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_METODOS_PROCESAMIENTO}_REJECTED`:
      return {
        ...state,
        tiposMetodosProcesamiento: {
          ...state.tiposMetodosProcesamiento,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_METODOS_PROCESAMIENTO}_FULFILLED`:
      return {
        ...state,
        tiposMetodosProcesamiento: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_TIPOS_FUENTES}_PENDING`:
      return {
        ...state,
        tiposFuentes: { ...state.tiposFuentes, error: false, loading: true },
      };
    case `${GET_TIPOS_FUENTES}_REJECTED`:
      return {
        ...state,
        tiposFuentes: { ...state.tiposFuentes, error: true, loading: false },
      };
    case `${GET_TIPOS_FUENTES}_FULFILLED`:
      return {
        ...state,
        tiposFuentes: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_TIPOS_EQUIPOS_RADIOLOGICOS}_PENDING`:
      return {
        ...state,
        tiposEquiposRadiologicos: {
          ...state.tiposEquiposRadiologicos,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_EQUIPOS_RADIOLOGICOS}_REJECTED`:
      return {
        ...state,
        tiposEquiposRadiologicos: {
          ...state.tiposEquiposRadiologicos,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_EQUIPOS_RADIOLOGICOS}_FULFILLED`:
      return {
        ...state,
        tiposEquiposRadiologicos: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_TIPOS_CARACTERISTICAS}_PENDING`:
      return {
        ...state,
        tiposCaracteristicas: {
          ...state.tiposCaracteristicas,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_CARACTERISTICAS}_REJECTED`:
      return {
        ...state,
        tiposCaracteristicas: {
          ...state.tiposCaracteristicas,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_CARACTERISTICAS}_FULFILLED`:
      return {
        ...state,
        tiposCaracteristicas: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_TIPOS_RADIACION}_PENDING`:
      return {
        ...state,
        tiposRadiacion: {
          ...state.tiposRadiacion,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_RADIACION}_REJECTED`:
      return {
        ...state,
        tiposRadiacion: {
          ...state.tiposRadiacion,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_RADIACION}_FULFILLED`:
      return {
        ...state,
        tiposRadiacion: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_SUSTANCIAS}_PENDING`:
      return {
        ...state,
        sustancias: { ...state.sustancias, error: false, loading: true },
      };
    case `${GET_SUSTANCIAS}_REJECTED`:
      return {
        ...state,
        sustancias: { ...state.sustancias, error: true, loading: false },
      };
    case `${GET_SUSTANCIAS}_FULFILLED`:
      return {
        ...state,
        sustancias: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };

    case `${GET_UNIDADES_MEDIDA}_PENDING`:
      return {
        ...state,
        unidadDeMedida: {
          ...state.unidadDeMedida,
          error: false,
          loading: true,
        },
      };
    case `${GET_UNIDADES_MEDIDA}_REJECTED`:
      return {
        ...state,
        unidadDeMedida: {
          ...state.unidadDeMedida,
          error: true,
          loading: false,
        },
      };
    case `${GET_UNIDADES_MEDIDA}_FULFILLED`:
      return {
        ...state,
        unidadDeMedida: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_EQUIPOS_RADIOLOGICOS}_PENDING`:
      return {
        ...state,
        equiposRadiologicos: {
          ...state.equiposRadiologicos,
          error: false,
          loading: true,
        },
      };
    case `${GET_EQUIPOS_RADIOLOGICOS}_REJECTED`:
      return {
        ...state,
        equiposRadiologicos: {
          ...state.equiposRadiologicos,
          error: true,
          loading: false,
        },
      };
    case `${GET_EQUIPOS_RADIOLOGICOS}_FULFILLED`:
      return {
        ...state,
        equiposRadiologicos: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case ADD_PROVEEDOR_COMPRADOR:
      let esComprador = action.payload.values.esComprador;
      let listProvedoresCompradoresAux = esComprador ? [...state.abmSustancia.compradores] : [...state.abmSustancia.proveedores];
      if (action.payload.id !== null && action.payload.id !== undefined) {
        listProvedoresCompradoresAux[action.payload.id] = action.payload.values;
      } else {
        listProvedoresCompradoresAux.push(action.payload.values);
      }
      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          [esComprador ? 'compradores' : 'proveedores']: listProvedoresCompradoresAux,
        },
      };
    case REMOVE_PROVEEDOR_Comprador:
      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          [action.payload.esComprador ? 'compradores' : 'proveedores']: state.abmSustancia[action.payload.esComprador ? 'compradores' : 'proveedores'].filter(
            (v, i) => !action.payload.id.includes(i)
          ),
        },
      };
    case ADD_ESTUDIO_AMBIENTAL:
      let estudioAmbientalesAux = [...state.abmSustancia.estudios];
      if (action.payload.id !== null) {
        estudioAmbientalesAux[action.payload.id] = action.payload.values;
      } else {
        estudioAmbientalesAux.push(action.payload.values);
      }
      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          estudios: estudioAmbientalesAux,
        },
      };
    case REMOVE_ESTUDIO_AMBIENTAL:
      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          estudios: state.abmSustancia.estudios.filter(
            (v, i) => !action.payload.includes(i)
          ),
        },
      };

    case `${GET_TIPOS_ESTUDIO}_PENDING`:
      return {
        ...state,
        tiposEstudio: {
          ...state.tiposEstudio,
          error: false,
          loading: true,
        },
      };
    case `${GET_TIPOS_ESTUDIO}_REJECTED`:
      return {
        ...state,
        tiposEstudio: {
          ...state.tiposEstudio,
          error: true,
          loading: false,
        },
      };
    case `${GET_TIPOS_ESTUDIO}_FULFILLED`:
      return {
        ...state,
        tiposEstudio: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_FRECUENCIAS_ESTUDIO}_PENDING`:
      return {
        ...state,
        frecuenciasEstudio: {
          ...state.frecuenciasEstudio,
          error: false,
          loading: true,
        },
      };
    case `${GET_FRECUENCIAS_ESTUDIO}_REJECTED`:
      return {
        ...state,
        frecuenciasEstudio: {
          ...state.frecuenciasEstudio,
          error: true,
          loading: false,
        },
      };
    case `${GET_FRECUENCIAS_ESTUDIO}_FULFILLED`:
      return {
        ...state,
        frecuenciasEstudio: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_METODOLOGIAS_EMPLEADAS}_PENDING`:
      return {
        ...state,
        metodologiasEmpleadas: {
          ...state.metodologiasEmpleadas,
          error: false,
          loading: true,
        },
      };
    case `${GET_METODOLOGIAS_EMPLEADAS}_REJECTED`:
      return {
        ...state,
        metodologiasEmpleadas: {
          ...state.metodologiasEmpleadas,
          error: true,
          loading: false,
        },
      };
    case `${GET_METODOLOGIAS_EMPLEADAS}_FULFILLED`:
      return {
        ...state,
        metodologiasEmpleadas: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };

    case `${GET_MODOS_EMPLEO}_PENDING`:
      return {
        ...state,
        modosEmpleo: {
          ...state.modosEmpleo,
          error: false,
          loading: true,
        },
      };
    case `${GET_MODOS_EMPLEO}_REJECTED`:
      return {
        ...state,
        modosEmpleo: {
          ...state.modosEmpleo,
          error: true,
          loading: false,
        },
      };
    case `${GET_MODOS_EMPLEO}_FULFILLED`:
      return {
        ...state,
        modosEmpleo: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case `${GET_USOS_ORIGEN}_PENDING`:
      return {
        ...state,
        usosOrigen: {
          ...state.usosOrigen,
          error: false,
          loading: true,
        },
      };
    case `${GET_USOS_ORIGEN}_REJECTED`:
      return {
        ...state,
        usosOrigen: {
          ...state.usosOrigen,
          error: true,
          loading: false,
        },
      };
    case `${GET_USOS_ORIGEN}_FULFILLED`:
      return {
        ...state,
        usosOrigen: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };

    case ADD_USOS:
      let usosAux = [...state.abmSustancia.usos];
      if (action.payload.id !== null) {
        usosAux[action.payload.id] = action.payload.values;
      } else {
        usosAux.push(action.payload.values);
      }
      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          usos: usosAux,
        },
      };
    case REMOVE_USOS:
      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          usos: state.abmSustancia.usos.filter(
            (v, i) => !action.payload.includes(i)
          ),
        },
      };
    case `${GET_DATOS_EQUIPO_RADIOLOGICO_ESTABLECIMIENTO}_PENDING`:
      return {
        ...state,
        datosEquipoRadiologico: {
          ...state.datosEquipoRadiologico,
          error: false,
          loading: true,
        },
      };
    case `${GET_DATOS_EQUIPO_RADIOLOGICO_ESTABLECIMIENTO}_REJECTED`:
      return {
        ...state,
        datosEquipoRadiologico: {
          ...state.datosEquipoRadiologico,
          error: true,
          loading: false,
        },
      };
    case `${GET_DATOS_EQUIPO_RADIOLOGICO_ESTABLECIMIENTO}_FULFILLED`:
      return {
        ...state,
        datosEquipoRadiologico: {
          data: action.payload.data,
          loading: false,
          error: false,
        },
      };
    case ADD_DATOS_SUSTANCIA:
      return {
        ...state,
        abmSustancia: {
          ...state.abmSustancia,
          sustancia: action.payload,
        },
      };
    case SET_EDIT_SUSTANCIA:
      return {
        ...state,
        abmSustancia: {
          ...INITIAL_STATE.abmSustancia,
          ...action.payload.values,
          idTabla: action.payload.id,
        },
      };
    case ADD_CONTRATISTA:
      return {
        ...state,
        contratistas: {
          ...state.contratistas,
          data: [...state.contratistas.data, action.payload],
        },
      };

    case EDIT_CONTRATISTA:
      const updatedContratistas = [...state.contratistas.data];
      const contratistaToUpdate = updatedContratistas.filter(
        (e) => e.id !== action.payload.id
      );
      contratistaToUpdate.push(action.payload);
      return {
        ...state,
        contratistas: {
          ...state.contratistas,
          data: contratistaToUpdate,
        },
      };

    case DELETE_CONTRATISTA:
      return {
        ...state,
        contratistas: {
          ...state.contratistas,
          data: state.contratistas.data.filter(
            (_, index) => index !== action.payload
          ),
        },
      };

    // Empresas Reducer Cases
    case ADD_EMPRESA:
      return {
        ...state,
        empresas: {
          ...state.empresas,
          data: [...state.empresas.data, action.payload],
        },
      };

    case EDIT_EMPRESA:
      const updatedEmpresas = [...state.empresas.data];
      const empresaToUpdate = updatedEmpresas.filter(
        (e) => e.id !== action.payload.id
      );
      empresaToUpdate.push(action.payload);
      return {
        ...state,
        empresas: {
          ...state.empresas,
          data: empresaToUpdate,
        },
      };

    case DELETE_EMPRESA:
      return {
        ...state,
        empresas: {
          ...state.empresas,
          data: state.empresas.data.filter(
            (_, index) => index !== action.payload
          ),
        },
      };
    case CLEAR_POST_RES:
      return {
        ...state,
        postResolucion: INITIAL_STATE.postResolucion,
        contratistas: INITIAL_STATE.contratistas,
        empresas: INITIAL_STATE.empresas,
      }
    case `${CLEAR_RES}`:
      return INITIAL_STATE;
    case `${GET_NOMINAS_ACTIVAS_ESTABLECIMIENTO}_PENDING`:
      return {
        ...state,
        nominasActivasEstablecimiento: {
          ...state.nominasActivasEstablecimiento,
          error: false,
          loading: true,
        },
      };
    case `${GET_NOMINAS_ACTIVAS_ESTABLECIMIENTO}_REJECTED`:
      return {
        ...state,
        nominasActivasEstablecimiento: {
          ...state.nominasActivasEstablecimiento,
          error: true,
          loading: false,
        },
      };
    case `${GET_NOMINAS_ACTIVAS_ESTABLECIMIENTO}_FULFILLED`:
      return {
        ...state,
        nominasActivasEstablecimiento: {
          ...state.nominasActivasEstablecimiento,
          error: false,
          loading: false,
          data: action.payload,
        },
      };
    case `${GET_INFO_ESTRUCTURA_ARCHIVO_CANCERIGENO}_PENDING`:
      return {
        ...state,
        infoEstructuraArchivoCancerigeno: {
          ...state.infoEstructuraArchivoCancerigeno,
          error: false,
          loading: true,
        },
      };
    case `${GET_INFO_ESTRUCTURA_ARCHIVO_CANCERIGENO}_REJECTED`:
      return {
        ...state,
        infoEstructuraArchivoCancerigeno: {
          ...state.infoEstructuraArchivoCancerigeno,
          error: true,
          loading: false,
        },
      };
    case `${GET_INFO_ESTRUCTURA_ARCHIVO_CANCERIGENO}_FULFILLED`:
      return {
        ...state,
        infoEstructuraArchivoCancerigeno: {
          ...state.infoEstructuraArchivoCancerigeno,
          error: false,
          loading: false,
          data: action.payload.data,
        },
      };
    case `${EXPORTAR_ARCHIVO_CANCERIGENOS}_PENDING`:
      return {
        ...state,
        exportarArchivoCancerigenos: {
          ...state.exportarArchivoCancerigenos,
          error: false,
          loading: true,
        },
      };
    case `${EXPORTAR_ARCHIVO_CANCERIGENOS}_REJECTED`:
      return {
        ...state,
        exportarArchivoCancerigenos: {
          ...state.exportarArchivoCancerigenos,
          error: true,
          loading: false,
        },
      };
    case `${EXPORTAR_ARCHIVO_CANCERIGENOS}_FULFILLED`:
      return {
        ...state,
        exportarArchivoCancerigenos: {
          ...state.exportarArchivoCancerigenos,
          error: false,
          loading: false,
          data: action.payload,
        },
      };
    case `${GET_PRESENTACIONES_415}_REJECTED`:
      return {
        ...state,
        presentaciones415: {
          ...state.presentaciones415,
          error: true,
          loading: false,
        }
      }
    case `${GET_PRESENTACIONES_415}_PENDING`:
      return {
        ...state,
        presentaciones415: {
          ...state.presentaciones415,
          error: false,
          loading: true,
        }
      }
    case `${GET_PRESENTACIONES_415}_FULFILLED`:
      return {
        ...state,
        presentaciones415: {
          ...state.presentaciones415,
          error: false,
          loading: false,
          data: action.payload,
        }
      }
    case `${GET_FORMULARIOS_PRESENTACION}_REJECTED`:
      return {
        ...state,
        formulariosPresentacion: {
          ...state.formulariosPresentacion,
          error: true,
          loading: false,
        }
      }
    case `${GET_FORMULARIOS_PRESENTACION}_PENDING`:
      return {
        ...state,
        formulariosPresentacion: {
          ...state.formulariosPresentacion,
          error: false,
          loading: true,
        }
      }
    case `${GET_FORMULARIOS_PRESENTACION}_FULFILLED`:
      return {
        ...state,
        formulariosPresentacion: {
          ...state.formulariosPresentacion,
          error: false,
          loading: false,
          data: action.payload?.data || action.payload,
        }
      }
    case `${GET_MUESTRA_VIGENTE}_PENDING`:
      return {
        ...state,
        muestraVigente: {
          ...state.muestraVigente,
          loading: true,
          error: false,
          data: null,
        }
      }
    case `${GET_MUESTRA_VIGENTE}_REJECTED`:
      return {
        ...state,
        muestraVigente: {
          ...state.muestraVigente,
          loading: false,
          error: true,
        }
      }
    case `${GET_MUESTRA_VIGENTE}_FULFILLED`:
      return {
        ...state,
        muestraVigente: {
          ...state.muestraVigente,
          loading: false,
          error: false,
          data: action.payload,
        }
      }
    case `${POST_PRESENTACION_415}_PENDING`:
      return {
        ...state,
        postPresentacion415: {
          ...state.postPresentacion415,
          loading: true,
          error: false,
        }
      }
    case `${POST_PRESENTACION_415}_REJECTED`:
      return {
        ...state,
        postPresentacion415: {
          ...state.postPresentacion415,
          loading: false,
          error: true,
        }
      }
    case `${POST_PRESENTACION_415}_FULFILLED`:
      return {
        ...state,
        postPresentacion415: {
          ...state.postPresentacion415,
          loading: false,
          error: false,
          data: action.payload,
        }
      }
    default:
      return state;
  }
};

export default resolucion;
